const SettingsDescription = {
  email_after_confirmation: 'Once an invoice is confirmed, it will be emailed to the customer\'s email for customer eligible for the "email" shipping method',
};

export default SettingsDescription;
